export default __webpack_public_path__ + "static/media/userGroupIcon-light.71709686.svg";